<template>
  <div>
    <validation-observer ref="scheduleItem">
      <b-form @submit.prevent=""
        @reset.prevent="resetForm">
        <validation-provider #default="validationContext"
          name="Tiêu đề"
          vid="title"
          rules="required">
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Tiêu đề <span class="text-danger">*</span></label>
            </template>
            <b-form-input type="text"
              v-model="frmData.title"
              :state="getValidationState(validationContext)"
              placeholder="Nhập..." />
            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider #default="validationContext"
          name="Tên file"
          vid="filename"
          rules="required">
          <b-form-group>
            <template #label>
              <label class="d-block font-weight-bolder pb-0">Tên file <span class="text-danger">*</span></label>
            </template>
            <b-form-input type="text"
              v-model="frmData.filename"
              :state="getValidationState(validationContext)"
              placeholder="Nhập..." />
            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <b-form-group>
          <template #label>
            <label class="d-block font-weight-bolder pb-0">Mô tả</label>
          </template>
          <b-form-input type="text"
            v-model="frmData.desc"
            placeholder="Nhập..." />
        </b-form-group>
        <div class="d-flex mt-1">
          <b-button variant="danger"
            type="submit"
            @click.prevent="validationForm"> {{ $t('Save') }} </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { required, email, alphaNum, min, max, } from '@validations'
import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { showToast, useRouter } from '@core/utils/utils';
import vSelect from 'vue-select'
export default {

  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormCheckboxGroup,
    vSelect
  },
  props: {
    dataEdit: {
      type: Object,
      default: null
    },
    dataChannelGroup: Array,
    dataType: Array
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const blankData = {
      title: '',
      description: '',
      channel_id: '',
      filename: '',
      author: '',
      channel_id: '',
      device: 'cmsvov',
      status: 1,
      json: {}
    }
    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    if (Object.keys(props.dataEdit).length > 0) {
      frmData.value.channel_id = props.dataEdit.id

      frmData.value.json = {
        app_name: props.dataEdit.channel_group.app_name,
        stream_name: props.dataEdit.stream_name,
        station: props.dataEdit.channel_group.station,
        channel_id: props.dataEdit.id
      }
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)

    return {
      frmData,
      refFormObserver,
      resetForm,
      getValidationState,
      resetfrmData,
    }
  },
  methods: {
    onSubmit() {

      store.dispatch('channel/create', { card_type: 'schedule_item', params: this.frmData })
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            showToast(result.message, { variant: 'success' });
            this.$emit('updateLiveStream');
            this.resetfrmData()
          } else {
            if (result.errors.length > 0) {
              this.$refs.scheduleItem.setErrors(result.errors);
            } else {
              showToast(result.message);
            }
          }
        })
    },
    validationForm() {
      this.errorMessage = {}
      this.$refs.scheduleItem.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
  }
}
</script>
<style lang="scss">
.col-form-label {
  font-size: 1.1rem;
  font-weight: bold
}

.custom-control-label {
  cursor: pointer;
}

.custom-control.custom-checkbox {
  padding-bottom: 0.5rem;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>